

export class Payment {
  public id: string;
  public paymentID: number;
  public paymentLogo: string;
  public title: string;
  public description: string;
  public createdDate: Date;
  public updatedDate: Date;
  public isActive: boolean;
  public isDefault: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/payment/payment-model.ts